// Networks.jsx  (renamed to Statistics in the UI; file kept as-is for routing compatibility)
import React from 'react';
import StatisticsTab from '../components/StatisticsTab';

export default function Networks() {
    return <StatisticsTab />;
}